import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import { API_GET_ACTIVITY_LOG, API_GET_DOCUMENT_SIGNED_URL, API_GET_DOCUMENTS } from "../../../shared/routes/private.routes";
const config = {
    name: "activity-log",
  };
  
  export const getActivityLogs: any = createAsyncThunk(
    `${config.name}/get-activity-logs`,
    async (id: string) => {
      return Client.get(API_GET_ACTIVITY_LOG+`${id}`);
    }
  );

  export const getDocuments: any = createAsyncThunk(
    `${config.name}/get-documents`,
    async (id: string) => {
      const result = await Client.get(API_GET_DOCUMENTS+`${id}`);
      return result?.data
    }
  );

  export const getSignedUrl: any = createAsyncThunk(
    `${config.name}/get-signed-url`,
    async ({module,params}:{module: string,params:any}) => {
      return Client.get(API_GET_DOCUMENT_SIGNED_URL+`${module}`,{params});
    }
  );

  export const activityLogReducer = createSlice({
    name: config.name,
    initialState: {},
    reducers: {}
  })

  export default activityLogReducer.reducer;